document.addEventListener("DOMContentLoaded", () => {
    const overlay = document.querySelector(".standorte-overlay");
    const standorteInner = document.querySelector(".standorte-inner");
    const logoItems = document.querySelectorAll(".standort-logo-item");
    const overlayContents = document.querySelectorAll(".overlay-content");
    const closeButtons = document.querySelectorAll(".overlay-close");
    const svgMap = document.querySelector('.standorte-map svg');

    if (!overlay || !standorteInner) return;

    // Höhe dynamisch setzen
    const updateOverlayHeight = () => {
        overlay.style.height = `${standorteInner.offsetHeight}px`;
    };

    window.addEventListener("resize", updateOverlayHeight);
    updateOverlayHeight();


    // Overlay öffnen
    logoItems.forEach(item => {
        item.addEventListener("click", () => {
            const id = item.dataset.overlayId;

            // vorher alle Inhalte ausblenden
            overlayContents.forEach(c => c.classList.remove("is-open"));

            // passenden Inhalt einblenden
            const targetContent = overlay.querySelector(`.overlay-content[data-overlay-id="${id}"]`);
            if (targetContent) {
                targetContent.classList.add("is-open");
            }

            // Overlay aktivieren
            overlay.classList.add("is-active");
        });

        const mapId = item.dataset.mapId;

        if (mapId) {
            item.addEventListener("mouseover", () => {
                svgMap.querySelector(`#${mapId}`).classList.add("is-hovered");
            });
            item.addEventListener("mouseout", () => {
                svgMap.querySelector(`#${mapId}`).classList.remove("is-hovered");
            });
        }
    });

    svgMap.querySelectorAll('g:not(#map)').forEach(element => {
        element.addEventListener("mouseenter", (e) => {
            console.log(e.currentTarget);
            logoItems.forEach(item => {
                if (item.dataset.mapId === e.currentTarget.id) {
                    item.classList.add("is-hovered");
                }
            });
        });

        element.addEventListener("mouseleave", () => {
            logoItems.forEach(item => item.classList.remove("is-hovered"));
        });
    });


    // Overlay schließen
    closeButtons.forEach(button => {
        button.addEventListener("click", () => {
            overlay.classList.remove("is-active");

            // Inhalte nach der Animation ausblenden
            setTimeout(() => {
                overlayContents.forEach(c => c.classList.remove("is-open"));
            }, 300); // Dauer der CSS-Animation anpassen
        });
    });
});
